export const filterUserGroups = (rows, id, filterValue) => {
    if (!filterValue) return rows;

    return rows.filter(row => {
        const rowValue = row.values[id];

        if (!Array.isArray(rowValue)) return false

        return rowValue.some(item => {
            return item?.value
                ?.toLowerCase()
                .includes(filterValue.toLowerCase());
        });
    });
};

export const sortBoolean = (rowA, rowB, columnId) => {
    const a = rowA.values[columnId] ? 1 : 0;
    const b = rowB.values[columnId] ? 1 : 0;

    if (a > b) return 1;
    if (b > a) return -1;
    return 0;
};

export const sortUserGroups = (rowA, rowB, columnId) => {
    const valueA = (rowA.values[columnId] || []).map(it => it.value).sort().join(', ').toLowerCase();
    const valueB = (rowB.values[columnId] || []).map(it => it.value).sort().join(', ').toLowerCase();

    if (valueA > valueB) return 1;
    if (valueA < valueB) return -1;
    return 0;
};